import React, { Component } from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Grid from "@material-ui/core/Grid";
import logo from "../images/logo.png";
import AdmissionContext from "../AdmissionContext";
import { kPButton } from "../global";

class ConsentView extends Component {
  static contextType = AdmissionContext;

  componentDidMount() {}

  render() {
    const { agree, chkAgreeValueChange, btnContinueClicked } = this.context;
    return (
      <div>
        {/* title */}
        <Box display="flex" justifyContent="center" pt={2}>
          <Grid container spacing={1}>
          <Grid item xs={1} sm={2} lg={3}></Grid>
          <Grid item xs={10} sm={8} lg={6}>
              <Card
                style={{
                  border: 0,
                  // minWidth: 100,
                  // maxWidth: 600,
                }}
                variant="outlined"
              >
                <CardMedia>
                  <Box display="flex" justifyContent="center" pt={1}>
                    <div>
                      <img src={logo} alt="" />
                    </div>
                  </Box>
                </CardMedia>
                <CardContent>
                  <Typography component="div">
                    <Box
                      fontWeight={500}
                      fontSize={22}
                      color="#388e3c"
                      display="flex"
                      justifyContent="center"
                    >
                      Online Admission
                    </Box>
                  </Typography>

                  {this.AcademicYear()}

                  {/* title */}
                  <Typography component="div">
                    <Box
                      fontSize={16}
                      color="#808080"
                      display="flex"
                      justifyContent="center"
                      pt={1}
                    >
                      CONSENT
                    </Box>
                  </Typography>

                  {/* title */}
                  <Typography component="div" align="justify">
                    <Box
                      fontSize={14}
                      color="#808080"
                      display="flex"
                      justifyContent="center"
                      pt={2}
                    >
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;I HEREBY CERTIFY that all
                      information indicated in this form and on the digital/physical documents
                      attached in this application for free tuition 2017 program
                      are true and correct and that any concealment or
                      misrepresentation of facts therein found will adversely
                      affect my application.
                    </Box>
                  </Typography>
                  {/* title */}
                  <Typography component="div" align="justify">
                    <Box
                      fontSize={14}
                      color="#808080"
                      display="flex"
                      justifyContent="center"
                      pt={1}
                    >
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Likewise, I am fully aware
                      that DLSP may share such information to affiliated or
                      partner organizations as part of its contractual
                      obligations, or with government agencies pursuant to law
                      or legal processes. In this regard, I hereby allow DLSP to
                      collect, process, use and share my personal data in the
                      pursuit of its legitimate academic, research, and
                      employment purposes and/or interests as an educational
                      institution.
                    </Box>
                  </Typography>

                  <Box
                    fontSize={14}
                    color="#808080"
                    display="flex"
                    justifyContent="center"
                    pt={1}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="chkAgree"
                          checked={agree}
                          onChange={(e) => {
                            chkAgreeValueChange(e.target.checked);
                          }}
                          style={{
                            color: "#388e3c",
                          }}
                        />
                      }
                      label="Agree"
                    />
                  </Box>

                  <Box justifyContent="center" display="flex" pt={2}>
                    <Box width={150}>
                      <Button
                        fullWidth={true}
                        style={kPButton}
                        variant="contained"
                        onClick={() => {
                          btnContinueClicked();
                        }}
                      >
                        Continue
                      </Button>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={1} sm={2} lg={3}></Grid>
          </Grid>
        </Box>
      </div>
    );
  }

  AcademicYear = () => {
    const { semester, year } = this.context;

    if (year === "") {
      return null;
    }

    var strSemester = "";
    if (parseInt(semester) === 1) strSemester = "1st Semester";
    if (parseInt(semester) === 2) strSemester = "2nd Semester";
    if (parseInt(semester) === 3) strSemester = "Midyear";

    return (
      <Typography component="div">
        <Box
          fontSize={14}
          color="#808080"
          display="flex"
          justifyContent="center"
        >
          ({strSemester} A.Y. {year})
        </Box>
      </Typography>
    );
  };
}

export default ConsentView;
